import { Component, Input, ViewChild, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { AnalyticsChartComponent } from '../../analytics-chart/analytics-chart.component';

@Component({
  selector: 'app-mission-performance-view',
  templateUrl: './mission-performance-view.component.html',
  styleUrl: './mission-performance-view.component.scss'
})
export class MissionPerformanceView implements OnInit, OnChanges {
  @Input() filters?: Record<string, any[]> | null = null;
  @ViewChild('missionChart') missionChart?: AnalyticsChartComponent;

  selectedGroup: 'day' | 'month' | 'year' = 'day';
  analyticsQuery = 'mission-per-day';
  resultsLabelsKey = 'day';

  pickingFilters: Record<string, any[]> = { type: ['-1'], groupBy: ['day'] };
  refillingFilters: Record<string, any[]> = { type: ['1'], groupBy: ['day'] };

  isExportingMissionAnalytics = false;
  isExportingTrendChart = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filters']) {
      this.updateFilterReferences();
    }
  }

  ngOnInit(): void {
    this.updateFilterReferences();
  }

  updateFilterReferences(): void {
    this.pickingFilters = this.mergeFilters({ type: ['-1'], groupBy: [this.selectedGroup] });
    this.refillingFilters = this.mergeFilters({ type: ['1'], groupBy: [this.selectedGroup] });
  }

  mergeFilters(additionalFilters: Record<string, any[]>): Record<string, any[]> {
    return { ...(this.filters ?? {}), ...additionalFilters };
  }

  onGroupChange(value: string) {
    if (value === 'day' || value === 'month' || value === 'year') {
      this.selectedGroup = value;
      this.resultsLabelsKey = value;

      this.updateFilterReferences();

      setTimeout(() => {
        this.missionChart?.forceUpdate();
        this.missionChart?.showAllDatasets();
      }, 150);
    }
  }

  formatMs(value: number | string | null | undefined): string {
    if (value == null || value === '') return '';
    const n = Number(value);
    if (isNaN(n)) return '';

    const totalSeconds = Math.floor(n / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${minutes} minutes ${seconds} seconds`;
  }

  togglePickingDataset(): void {
    this.missionChart?.toggleDataset(1);
  }

  toggleRefillingDataset(): void {
    this.missionChart?.toggleDataset(0);
  }

  showAllDatasets(): void {
    this.missionChart?.showAllDatasets();
  }

  hideAllDatasets(): void {
    this.missionChart?.hideAllDatasets();
  }

  isPickingVisible(): boolean {
    return this.missionChart?.isDatasetVisible(0) ?? true;
  }

  isRefillingVisible(): boolean {
    return this.missionChart?.isDatasetVisible(1) ?? true;
  }
}
